import gi from "./client-hints-parser.js";
import Si from "./user-agent-parser.js";
import { Browsers as bi, OperatingSystems as so } from "./device-constants.js";
class vi {
  constructor() {
    let t;
    (t =
      navigator.userAgent.toLowerCase().includes(bi.Sg.toLowerCase()) ||
      !navigator.userAgentData
        ? Si
        : gi),
      (this.vg = new t()),
      (this.userAgent = navigator.userAgent),
      (this.browser = this.vg.ff()),
      (this.version = this.vg.cf()),
      (this.OS = null),
      this.rc().then((t) => (this.OS = t));
    const i = navigator;
    (this.language = (
      i.userLanguage ||
      i.language ||
      i.browserLanguage ||
      i.systemLanguage ||
      ""
    ).toLowerCase()),
      (this.Il = vi.xg(this.userAgent));
  }
  fE() {
    return this.browser === bi.Bg;
  }
  nc() {
    return this.OS || null;
  }
  rc() {
    return this.OS
      ? Promise.resolve(this.OS)
      : this.vg.rc(vi.Og).then((t) => ((this.OS = t), t));
  }
  static xg(t) {
    t = t.toLowerCase();
    const i = [
      "bot",
      "slurp",
      "baiduspider",
      "yandex",
      "facebookexternalhit",
      "sogou",
      "ia_archiver",
      "https://github.com/prerender/prerender",
      "aolbuild",
      "bingpreview",
      "mediapartners-google",
      "teoma",
      "taiko",
      "facebookexternalhit",
      "facebookcatalog",
      "meta-webindexer",
      "meta-externalads",
      "meta-externalagent",
      "meta-externalfetcher",
    ];
    for (let n = 0; n < i.length; n++) if (-1 !== t.indexOf(i[n])) return !0;
    return !1;
  }
}
vi.Og = [
  { string: navigator.platform, uf: "Win", identity: so.kg },
  { string: navigator.platform, uf: "Mac", identity: so.Pg },
  { string: navigator.platform, uf: "BlackBerry", identity: "BlackBerry" },
  { string: navigator.platform, uf: "FreeBSD", identity: "FreeBSD" },
  { string: navigator.platform, uf: "OpenBSD", identity: "OpenBSD" },
  { string: navigator.platform, uf: "Nintendo", identity: "Nintendo" },
  { string: navigator.platform, uf: "SunOS", identity: "SunOS" },
  { string: navigator.platform, uf: "PlayStation", identity: "PlayStation" },
  { string: navigator.platform, uf: "X11", identity: "X11" },
  {
    string: navigator.userAgent,
    uf: ["iPhone", "iPad", "iPod"],
    identity: so.co,
  },
  { string: navigator.platform, uf: "Pike v", identity: so.co },
  { string: navigator.userAgent, uf: ["Web0S"], identity: "WebOS" },
  { string: navigator.userAgent, uf: "Tizen", identity: "Tizen" },
  { string: navigator.userAgent, uf: "Coolita", identity: "Other Smart TV" },
  { string: navigator.userAgent, uf: "WhaleTV", identity: "Other Smart TV" },
  {
    string: navigator.platform,
    uf: ["Linux armv7l", "Android"],
    identity: so.Dg,
  },
  { string: navigator.userAgent, uf: ["Android"], identity: so.Dg },
  { string: navigator.platform, uf: "Linux", identity: "Linux" },
];
const ro = new vi();
export { ro as default, vi as BrowserDetector };
